import { styled } from "styled-components";

import { Image, UIButton } from "common/components";
import { lineTruncationStyle } from "common/styles";
import { useDispatch } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { setTransformationMapInnerNode } from "domains/transformationMap/actions";
import type { Topic } from "entities/topics/types";

const StyledContainer = styled.div`
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledTitle = styled.h3`
  margin: 0;
  margin-top: calc(1rem - 8px);
  padding-bottom: 10px;
`;

const StyledSubtitle = styled.p`
  margin: 0;
  ${lineTruncationStyle(3)}
`;

const StyledRow = styled.div`
  display: flex;
`;

const StyledImage = styled(Image)`
  width: 100px;
  min-width: 100px;
  height: 100px;
  border-radius: 5px;
  margin-right: 1rem;
`;

type RelatedTopicCardProps = { isKeyIssue: boolean; scrollToTop: () => void; topic: Topic };

export const RelatedTopicCard = ({ topic, isKeyIssue, scrollToTop }: RelatedTopicCardProps) => {
  const dispatch = useDispatch();
  const go = useGo();
  const translate = useTranslate();

  const selectIssue = () => {
    if (isKeyIssue) go(`/topics/${topic.id}`);
    else dispatch(setTransformationMapInnerNode({ id: topic.id }));
    scrollToTop();
  };

  return (
    <StyledContainer>
      <StyledRow>
        {topic.images && <StyledImage src={topic.images.thumbnail} />}
        <div>
          <StyledTitle>{topic.name}</StyledTitle>
          <StyledSubtitle>{topic.description}</StyledSubtitle>
        </div>
      </StyledRow>
      <UIButton variant="outlined" onClick={selectIssue} fullwidth>
        {translate("app.message_banner.upgrade.button.2")}
      </UIButton>
    </StyledContainer>
  );
};
